import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

//Assets
import copy_icon from "../../assets/icons/copy_small.svg";
import success_icon from "../../assets/success_icon.svg";

//components
import Button from "../../components/Button";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../redux/store";
import { shortenAddress } from "../../utils/shortenAddress";

const MintInfoSection = ({ nftMetadata, handleBurnMintedProxyToken }: { nftMetadata: any; handleBurnMintedProxyToken: Function }) => {
  const [nftData, setNftData] = useState<any>({});
  const [showFullDescription, setShowFullDescription] = useState(false);

  const wallet = useSelector((state: RootState) => state.walletState);
  const navigate = useNavigate();

  useEffect(() => {
    if (nftMetadata && nftMetadata.metadata) {
      setNftData(JSON.parse(nftMetadata.metadata));
    }
  }, [nftMetadata]);
  return (
    <>
      {nftData && nftData.proxy_info ? (
        <>
          <section
            css={css`
              display: flex;
              border: 1px solid #ccc4b3;
              border-radius: 12px;
              padding: 32px;
              flex-direction: column;
            `}
          >
            <div
              css={css`
                display: 100%;
                display: flex;
              `}
            >
              <span
                css={css`
                  display: flex;
                  flex-direction: column;
                  width: 75%;
                  justify-content: center;
                  // align-items: center;
                `}
              >
                <h1
                  css={css`
                    font-weight: 700;
                    font-size: 24px;
                    margin: 0;
                    display: block;
                  `}
                >
                  Proxy Token Info
                </h1>
              </span>
              <img
                css={css`
                  width: 92px;
                  height: 92px;
                `}
                src={success_icon}
                alt=""
              />
            </div>
            <div
              css={css`
                display: flex;
                flex-direction: column;
                margin-top: 36px;
                gap: 24px;
              `}
            >
              <InfoTag
                label={"Asset Contract"}
                value={shortenAddress(nftData.proxy_info.nft_contract_id)}
                key={"info" + nftData.name}
              />
              <InfoTag
                label={"Asset ID"}
                value={nftData.proxy_info.nft_id}
                key={"nftID" + nftData.name}
              />
              <InfoTag
                label={"Token Standard"}
                value={"ERC721"}
                key={"info" + nftData.name}
              />
              <InfoTag
                label={"Blockchain"}
                value={
                  nftData.proxy_info.nft_asset_chain == "3" ? "POLYGON" : "ETH"
                }
                key={"info" + nftData.name}
              />

              {/* {["Asset Contract", "Asset ID", "Token Standard", "Blockchain"].map(
            (info) => {
              return (
              );
            }
          )} */}
            </div>
          </section>
          <span
            css={css`
              display: flex;
              padding-top: 40px;
            `}
          >
            <Button
              width="100%"
              type="OUTLINE"
              onClick={() => navigate("/proxy-tokens-list")}
            >
              Back
            </Button>
            <Button
              width="100%"
              type="BLACK"
              onClick={() => handleBurnMintedProxyToken()}
            >
              Burn
            </Button>
          </span>
        </>
      ) : (
        ""
      )}
    </>
  );
};

const InfoTag = ({ label, value }: { label: string; value: string }) => {
  return (
    <span
      css={css`
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
      `}
    >
      <p
        css={css`
          font-weight: 500;
          font-size: 16px;
          color: #757272;
          margin: 0;
          margin-right: auto;
          width: max-content;
        `}
      >
        {label}
      </p>
      <span
        css={css`
          display: flex;
          flex-grow: 1;
          border: 1px dashed #a29b8b84;
          margin: 0 8px;
          margin-top: auto;
          margin-bottom: 5px;
        `}
      ></span>
      <h1
        css={css`
          font-weight: 500;
          font-size: 16px;
          color: #191414;
          margin: 0;
          margin-left: auto;
        `}
      >
        {value}
      </h1>
      <img
        onClick={() => {
          navigator.clipboard.writeText(value);
        }}
        css={css`
          margin-left: 5px;
          cursor: pointer;
          &:hover {
            transition: all 0.2s ease-in-out;
            opacity: 0.4;
          }
        `}
        src={copy_icon}
        alt=""
      />
    </span>
  );
};

export default MintInfoSection;
